var dialogOpen = false, lastFocus, dialog, okbutton, pagebackground;

function openMainMenu() {
    lastFocus = document.activeElement;
    dialog = document.getElementById("site-header");
	pagebackground = document.getElementById("site-content");
    dialogOpen = true;
    document.getElementById("rt-open-main-menu").ariaExpanded = true;
    selectPrimaryMenu('all');
    body.classList.add('menu-opened');
    for (let child of document.getElementsByClassName("rt-main-menu-primary-button-all")) {
        if(child.offsetParent === null || child.style.display === 'none') {
            child.focus({ focusVisible: true });
            break;
        }
    }
}

function closeMainMenu() {
    body.classList.remove('menu-opened');
    closeSubmenu();
    dialogOpen = false;
    document.getElementById("rt-open-main-menu").ariaExpanded = false;
}

function showDialog() {
}

function selectFirstMainMenu() {
    selectPrimaryMenu('all');
}

function selectPrimaryMenu(slug) {
    'use strict';
    document.querySelectorAll('.rt-main-menu-primary-button').forEach(child => {
        if (child.classList.contains('selected')) {
            child.classList.remove('selected');
        }
        child.ariaExpanded = false;
    })
    document.querySelectorAll('.rt-main-menu-primary-button-' + slug).forEach(child => {
        child.classList.add('selected');
        child.ariaExpanded = true;
    });
    const secondaryMenu = document.querySelectorAll('.rt-main-menu-secondary-' + slug)[0];
    document.querySelectorAll('.rt-main-menu-secondary').forEach(child => {
        if (child.classList.contains('selected')) {
            child.classList.remove('selected');
        }
    })
    secondaryMenu.classList.add('selected');
    secondaryMenu.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')[0].focus({ focusVisible: true })

    unselectSubmenu();
}

function showSubmenu(el, slug) {
    'use strict';
    unselectSubmenu();
    const secondaryMenu = document.querySelectorAll('.submenu-' + slug)[0];
    el.ariaExpanded = true;
    secondaryMenu.classList.add('selected');
    const subitems = secondaryMenu.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    for (let item of subitems) {
        if(item.offsetParent === null || item.style.display === 'none') {
            item.focus({ focusVisible: true });
            break;
        }
    }
    
    // secondaryMenu.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').focus({ focusVisible: true });
    document.querySelectorAll('.rt-main-menu-content')[0].classList.add('submenu-selected');
}

function unselectSubmenu() {
    document.querySelectorAll('.rt-main-menu-secondary-submenu').forEach(child => {
        if (child.classList.contains('selected')) {
            child.classList.remove('selected');
        }
    })
    document.querySelectorAll('.rt-submenu-control').forEach(child => {
        child.ariaExpanded = false;
    })
}

function closeSubmenu() {
    'use strict';
    unselectSubmenu();
    document.querySelectorAll('.rt-main-menu-content')[0].classList.remove('submenu-selected');
}

document.addEventListener("focus", function(event) {
    var d = document.getElementById("site-header");
    if (dialogOpen && !d.contains(event.target)) {
        event.stopPropagation();
        document.getElementById("site-header").querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')[0].focus({ focusVisible: true })
    }

}, true);


document.addEventListener("keydown", function(event) {
    if (dialogOpen && event.keyCode == 27) {
        closeMainMenu();
    }
}, true);
